import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf24dae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { "aria-label": "Breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Home")
], -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "category-badge bg-red-hover" }
const _hoisted_8 = { class: "article-title" }
const _hoisted_9 = { class: "share-section" }
const _hoisted_10 = { class: "share-stats" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("by ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 0")
const _hoisted_13 = { class: "share-buttons" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-label" }, " SHARE ", -1))
const _hoisted_15 = { class: "share-btn facebook" }
const _hoisted_16 = { class: "share-btn twitter" }
const _hoisted_17 = { class: "share-btn google" }
const _hoisted_18 = { class: "share-btn linkedin" }
const _hoisted_19 = { class: "share-btn email" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container" }, null, -1))
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "share-section" }
const _hoisted_23 = { class: "share-buttons" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-label" }, " SHARE ", -1))
const _hoisted_25 = { class: "share-btn facebook" }
const _hoisted_26 = { class: "share-btn twitter" }
const _hoisted_27 = { class: "share-btn google" }
const _hoisted_28 = { class: "share-btn linkedin" }
const _hoisted_29 = { class: "share-btn email" }
const _hoisted_30 = { class: "container" }
const _hoisted_31 = { class: "post-navigation" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "post-navigation__label" }, "Previous Post", -1))
const _hoisted_33 = { class: "post-navigation__title red-hover" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "post-navigation__label" }, "Next Post", -1))
const _hoisted_35 = { class: "post-navigation__title red-hover" }
const _hoisted_36 = { class: "author-section" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#1f1f1f"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-7-.5-14.5T799-507q-5 29-27 48t-52 19h-80q-33 0-56.5-23.5T560-520v-40H400v-80q0-33 23.5-56.5T480-720h40q0-23 12.5-40.5T563-789q-20-5-40.5-8t-42.5-3q-134 0-227 93t-93 227h200q66 0 113 47t47 113v40H400v110q20 5 39.5 7.5T480-160Z" })
], -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "related-articles" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "related-articles__title" }, "Relaterede Artikler", -1))
const _hoisted_41 = { class: "related-articles__grid" }
const _hoisted_42 = ["src", "onClick"]
const _hoisted_43 = { class: "article-card__title" }
const _hoisted_44 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBreadcrumbs(), (bread, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_va_icon, { name: "chevron_right" }),
              _createElementVNode("a", {
                href: bread.path
              }, _toDisplayString(bread.name), 9, _hoisted_6)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getBreadcrumbs()[0].name), 1),
      _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.postData.postTitle), 1),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, [
            _hoisted_11,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToAuthorPosts(_ctx.postData.postAuthorName.split(' ')[0]+ '-' + _ctx.postData.postAuthorName.split(' ')[1]))),
              class: "red-hover"
            }, _toDisplayString(_ctx.postData.postAuthorName), 1)
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'clock'] }),
            _createTextVNode(" " + _toDisplayString(_ctx.postData.postReleased), 1)
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'message'] }),
            _hoisted_12
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'eye'] }),
            _createTextVNode(" " + _toDisplayString(_ctx.postData.postViews), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLikes(_ctx.postData.postId))),
            class: _normalizeClass([_ctx.isLiked ? 'liked': '', "share-btn"])
          }, [
            _createVNode(_component_font_awesome_icon, {
              style: _normalizeStyle({ color: _ctx.isLiked ? 'white' : '' }),
              icon: ['fa', 'thumbs-up']
            }, null, 8, ["style"]),
            _createElementVNode("p", {
              style: _normalizeStyle({ color: _ctx.isLiked ? 'white' : '' })
            }, _toDisplayString(_ctx.likeCount), 5)
          ], 2),
          _createElementVNode("button", _hoisted_15, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook'] })
          ]),
          _createElementVNode("button", _hoisted_16, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'x-twitter'] })
          ]),
          _createElementVNode("button", _hoisted_17, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'google-plus-g'] })
          ]),
          _createElementVNode("button", _hoisted_18, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin'] })
          ]),
          _createElementVNode("button", _hoisted_19, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'envelope'] })
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showData]
      ]),
      _hoisted_20,
      _createElementVNode("div", {
        innerHTML: _ctx.postData.postContents,
        class: "v-html-container",
        style: {"margin-top":"13px"}
      }, null, 8, _hoisted_21),
      _withDirectives(_createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleLikes(_ctx.postData.postId))),
            class: _normalizeClass([_ctx.isLiked ? 'liked': '', "share-btn"])
          }, [
            _createVNode(_component_font_awesome_icon, {
              style: _normalizeStyle({ color: _ctx.isLiked ? 'white' : '' }),
              icon: ['fa', 'thumbs-up']
            }, null, 8, ["style"]),
            _createElementVNode("p", {
              style: _normalizeStyle({ color: _ctx.isLiked ? 'white' : '' })
            }, _toDisplayString(_ctx.likeCount), 5)
          ], 2),
          _createElementVNode("button", _hoisted_25, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook'] })
          ]),
          _createElementVNode("button", _hoisted_26, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'x-twitter'] })
          ]),
          _createElementVNode("button", _hoisted_27, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'google-plus-g'] })
          ]),
          _createElementVNode("button", _hoisted_28, [
            _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin'] })
          ]),
          _createElementVNode("button", _hoisted_29, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'envelope'] })
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showData]
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("nav", _hoisted_31, [
          (_ctx.previousPost)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewPostById(_ctx.previousPost))),
                class: "post-navigation__item post-navigation__item--prev cursor"
              }, [
                _hoisted_32,
                _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.previousPost?.indlaeg_slug), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.nextPost)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.viewPostById(_ctx.nextPost))),
                class: "post-navigation__item post-navigation__item--next cursor"
              }, [
                _hoisted_34,
                _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.nextPost?.indlaeg_slug), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h4", {
            class: "author-section__name red-hover",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToAuthorPosts(_ctx.postData.postAuthorName.split(' ')[0]+ '-' + _ctx.postData.postAuthorName.split(' ')[1])))
          }, _toDisplayString(_ctx.postData.postAuthorName), 1),
          _createElementVNode("div", {
            class: "author-section__icon red-hover",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.home()))
          }, _hoisted_38)
        ]),
        _createElementVNode("section", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedPosts, (post) => {
              return (_openBlock(), _createElementBlock("a", {
                href: "#",
                class: "article-card",
                key: post?.id
              }, [
                _createElementVNode("img", {
                  src: _ctx.extractImgUrl(post),
                  onClick: ($event: any) => (_ctx.viewPostById(post)),
                  alt: "Skomar Champ Trophy",
                  class: "article-card__image"
                }, null, 8, _hoisted_42),
                _createElementVNode("h3", _hoisted_43, _toDisplayString(post?.indlaeg_versionerings_id[_ctx.getIndexOfPostVersion(post?.indlaeg_version)]?.indlaeg_versionering_titel), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}